import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {
        DesignPage: {
            apiPath: '/page',
            filters: {
                name: {
                    type: 'string',
                    displayName: '关键字',
                },
                type: {
                    type: 'string.options.select',
                    displayName: '类型',
                    options: [],
                    source: {
                        apiPath: '/loader/design-type-filter',
                    },
                },
            },
            properties: {
                id: {
                    type: 'string',
                    displayName: 'ID',
                },
                type: {
                    type: 'string.options.select',
                    displayName: '类型',
                    options: [],
                    source: {
                        apiPath: '/loader/design-type',
                    },
                    controlConfig: {
                        placeholder: '请选择',
                        showSearch: false,
                    },
                    rules: [{ required: true }],
                },
                name: {
                    type: 'string',
                    displayName: '页面名称',
                    rules: [
                        { required: true, message: '请输入页面名称.' },
                        { max: 16, message: '最多可输入16个字符.' },
                    ],
                },
                enabled: {
                    type: 'boolean.switch',
                    displayName: '启用',
                },
                template: {
                    type: 'object.pageTemplate',
                    displayName: '模板',
                    // source: {
                    //     apiPath: '/template',
                    //     loadOnInit: true,
                    // },
                    rules: [{ required: true }],
                },
                margin: {
                    type: 'number.rowmargin',
                    displayName: '全局页面边距',
                    rules: [{ required: true }],
                },
                bgcolor: {
                    type: 'object.pageColorPicker',
                    displayName: '页面背景颜色',
                    // rules: [{ required: true }],
                },
                createTime: {
                    type: 'string',
                    displayName: '创建时间',
                },
                lastedModifyTime: {
                    type: 'string',
                    displayName: '修改时间',
                },
            },
        },
    },
    components: {
        PageManageView: {
            component: 'Viewport',
            entity: 'DesignPage',
        },
        PageManageDesign: {
            component: 'Card',
            content: {
                component: 'PageDesign',
                client: ENV.DESIGN_CLIENT_URL,
                type: 'page',
            },
        },
        PageManage: {
            component: 'Card',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                items: [
                    {
                        component: 'GridLayout',
                        style: {
                            marginBottom: 10,
                        },
                        items: [
                            {
                                component: 'Button',
                                text: '创建页面',
                                type: 'primary',
                                icon: 'plus',
                                span: 8,
                                route: 'page/add',
                            },
                            {
                                component: 'PageManageFilter',
                                span: 16,
                                style: {
                                    float: 'right',
                                },
                            },
                        ],
                    },

                    {
                        component: 'PageManageTable',
                    },
                ],
            },
        },
        PageManageFilter: {
            component: 'FilterForm',
            direction: 'inline',
            fields: [
                {
                    property: 'type',
                    controlConfig: {
                        placeholder: '请选择',
                        showSearch: false,
                        defaultValueIndex: 0,
                        style: { width: '160px' },
                    },
                },
                {
                    property: 'name',
                    controlConfig: {
                        style: { width: '160px' },
                    },
                },
            ],
            submit: { text: '搜索' },
        },
        PageManageTable: {
            component: 'DataTable',
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
            },
            columns: [
                {
                    property: 'id',
                },
                {
                    property: 'type',
                },
                // {
                //     property: 'template',
                // },
                {
                    property: 'name',
                },
                {
                    property: 'enabled',
                },
                {
                    property: 'createTime',
                },
                {
                    property: 'lastedModifyTime',
                },
            ],
            actionColumn: {
                title: '操作',
                items: [
                    {
                        type: 'link',
                        text: '设置',
                        path: 'page/edit/{{row.id}}',
                    },
                    {
                        type: 'link',
                        text: '装饰',
                        path: 'page/design/{{row.id}}',
                    },
                    {
                        type: 'component',
                        component: 'PagePreviewButton',
                        config: {
                            type: 'topic',
                        },
                    },
                    {
                        type: 'component',
                        component: 'PageCopyButton',
                        config: {
                            type: 'all',
                        },
                    },
                    {
                        type: 'component',
                        component: 'PageJsExportExcelButton',
                        config: {
                            type: 'all',
                        },
                    },
                    {
                        type: 'delete',
                        text: '删除',
                        config: {
                            type: 'link',
                            tooltip: null,
                            title: '确定删除当前页面吗?',
                            okText: '确定',
                            cancelText: '取消',
                        },
                    },
                ],
            },
        },
        PageManageAdd: {
            component: 'Card',
            title: '创建页面',
            entities: [{ name: 'DesignTemplate', entityName: 'DesignTemplate' }],
            content: {
                component: 'PageManageAddForm',
            },
        },
        PageManageAddForm: {
            component: 'CreateForm',
            entity: 'DesignPage',
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'type',
                },
                {
                    property: 'enabled',
                },
                {
                    property: 'template',
                },
                {
                    property: 'margin',
                },
                {
                    property: 'bgcolor',
                },
            ],
            labelCol: 8,
            submit: { text: '提交' },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            footer: {
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            style: {
                width: '400px',
            },
        },
        PageManageEdit: {
            component: 'Card',
            title: '设置页面',
            content: {
                component: 'PageManageEditForm',
            },
        },
        PageManageEditForm: {
            component: 'ModifyForm',
            entity: 'DesignPage',
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'type',
                },
                {
                    property: 'enabled',
                },
                {
                    property: 'margin',
                },
                {
                    property: 'bgcolor',
                },
            ],
            loaderType: 'get',
            labelCol: 8,
            submit: { text: '提交' },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            footer: {
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            style: {
                width: '400px',
            },
        },
    },

    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/design',
                    component: 'Viewport',
                    breadcrumbName: '页面配置管理',
                    childRoutes: [
                        {
                            path: '/page',
                            component: 'PageManageView',
                            breadcrumbName: '小程序页面管理',
                            childRoutes: [
                                {
                                    path: '/design/:id',
                                    component: 'PageManageDesign',
                                },
                                {
                                    path: '/add',
                                    component: 'PageManageAdd',
                                },
                                {
                                    path: '/edit/:id',
                                    component: 'PageManageEdit',
                                },
                                {
                                    path: '/',
                                    component: 'PageManage',
                                },
                            ],
                        },
                        {
                            path: '/template',
                            component: 'PageTemplateManageView',
                            breadcrumbName: '小程序模板管理',
                            childRoutes: [
                                {
                                    path: '/edit/:id',
                                    component: 'PageTemplateEdit',
                                },
                                {
                                    path: '/add',
                                    component: 'PageTemplateAdd',
                                },
                                {
                                    path: '/design/:id',
                                    component: 'PageTemplateDesignView',
                                },
                                {
                                    path: '/',
                                    component: 'PageTemplateManagePage',
                                },
                            ],
                        },
                        {
                            path: '/structure',
                            component: 'structureView',
                            breadcrumbName: '网站结构管理',
                        },
                        {
                            path: '/hotWords',
                            component: 'hotWordsView',
                            breadcrumbName: '热词管理',
                        },
                        {
                            path: '/sidebarMenu',
                            component: 'Viewport',
                            breadcrumbName: '侧边导航tab',
                            childRoutes: [
                                {
                                    path: '/add',
                                    component: 'SidebarMenuAdd',
                                    breadcrumbName: '新建tab内容',
                                },
                                {
                                    path: '/edit/:id/:idx',
                                    component: 'SidebarMenuAdd',
                                    breadcrumbName: '编辑tab内容',
                                },
                                {
                                    path: '/detail/:id',
                                    component: 'SidebarMenuDetail',
                                    breadcrumbName: '查看tab内容',
                                },

                                {
                                    path: '/',
                                    component: 'SidebarMenuView',
                                },
                            ],
                        },
                        {
                            path: '/floatingLayer',
                            component: 'Viewport',
                            breadcrumbName: '首页浮层管理',
                            childRoutes: [
                                {
                                    path: '/add',
                                    component: 'FloatingLayerAdd',
                                    breadcrumbName: '新建首页浮层',
                                },
                                {
                                    path: '/edit/:id/:readonly',
                                    component: 'FloatingLayerAdd',
                                    breadcrumbName: '编辑首页浮层',
                                },
                                {
                                    path: '/detail/:id/:readonly',
                                    component: 'FloatingLayerAdd',
                                    breadcrumbName: '首页浮层详情',
                                },
                                {
                                    path: '/',
                                    component: 'FloatingLayerView',
                                },
                            ],
                        },
                        {
                            path: '/lotteryConfig',
                            component: 'LotteryConfig',
                            breadcrumbName: '甄币抽奖链接设置',
                        },
                    ],
                },
            ],
        },
    ],
};
